<template>
    <Form id="mainform1" ref="formCustom" :model="formCustom" :rules="ruleCustom" style="float:left;margin:10px;">
        <FormItem v-if="isCouponShow" prop="couponValue">
            <Input :disabled="formCustom.isChecked" v-model="formCustom.couponValue" placeholder="请输入优惠券" />
            <p style="color:red;display:isRightPromoCode?'block':'none'; ">{{couponrltdesc}}</p>
        </FormItem>
        <FormItem v-if="isAgentShow" prop="agencies">
            <Input :disabled="formCustom.isChecked" v-model="formCustom.agencies" placeholder="请输入运营商编码"/>
            <p style="color:red;display:isRightAgentCode?'block':'none'; ">{{agentrltdesc}}</p>
        </FormItem>
        <Checkbox :disabled='isCheckBoxDisabled' v-if="isCouponShow || isAgentShow" v-model="formCustom.isChecked" @on-change="confirmCode">{{chxtxt}}</Checkbox>
        <div style="color:#19be6b;">{{discountmsg}}</div>
    </Form>
</template>
<script>
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    props: {
        isCouponShow: {
            type: Boolean,
            default: false,
        },
        isAgentShow: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            isCheckBoxDisabled:false,
            formCustom: {
                couponValue: '',
                agencies: '',
                isChecked: false,
            },
            ruleCustom: {
                couponValue: [
                    { trigger: 'blur' }
                ],
                agencies: [
                    { trigger: 'blur' }
                ],
            },
            isRightPromoCode: false,
            isRightAgentCode: false,
            couponrltdesc:'',
            agentrltdesc:'',
            rspItem: {},
        }
    },
    computed: {
        discountmsg: function() {
            if (!this.rspItem.item) {
                return ''
            } else {
                return this.rspItem.item.discountdesc
            }

        },
        chxtxt: function() {
            if (this.isCouponShow && this.isAgentShow) {
                return "确认使用优惠码和运营商编码"
            } else if (this.isCouponShow) {
                return "确认使用优惠码"
            } else if (this.isAgentShow) {
                return "确认使用运营商编码"
            }
        },

    },
    created() {
    },
    methods: {
        //如果用户存在已绑定的代理商编码则自动绑定，且不能修改，20210429
        setDefaultAgent(agent){
            this.formCustom.couponValue=''
            this.formCustom.agencies=agent.fromagent
            this.formCustom.isChecked=true
            this.isCheckBoxDisabled=true
            //this.agentrltdesc=agent.fromdesc
            this.$emit('on-check', this.formCustom)
        },
        confirmCode(value) {
            console.log(value)
            console.log(this.formCustom)
            this.$emit('on-check', this.formCustom)
            // if (value) {
            //     this.countPromocode()
            // } else {
            //     this.$refs.mycoupon.clean()
            //     this.loadDefaultPackages(this.rowData)
            // }

        },
        // onAgentChange(value) {
        //     this.$emit('on-input-change', value)
        // },
        // onCouponChange(value) {
        //     this.$emit('on-input-change', value)
        // },
        countPromocode(amount, func) {
            // this.promocode.couponcode = this.$refs.mycoupon.formCustom.couponValue
            // this.promocode.agentcode = this.$refs.mycoupon.formCustom.agencies
            let poData = {
                amount: amount,
                couponcode: this.formCustom.couponValue,
                agentcode: this.formCustom.agencies,
            }
            constJ.reqChcekCouponAndAgentcode(poData).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    let item = res.item
                    this.isRightPromoCode = item.couponrlt
                    this.isRightAgentCode = item.agentrlt
                    this.couponrltdesc=item.couponrltdesc
                    this.agentrltdesc=item.agentrltdesc
                    this.rspItem = res
                    func(this.rspItem)
                    //console.log(this.rspItem)
                }
                return res
            })
        },
        getConfirmInfo() {
            let rps = {
                rltdesc: '',
                iswarning: false
            }

            //判断是否勾选了确认使用
            if (!this.formCustom.isChecked && this.isCouponShow && this.isAgentShow) {
                rps.iswarning = true
                rps.rltdesc = '您没有确认使用优惠码或运营商编码，是否继续下单？'
                return rps
            }

            //判断是否勾选了确认使用
            if (!this.formCustom.isChecked && this.isCouponShow && !this.isAgentShow) {
                rps.iswarning = true
                rps.rltdesc = '您没有确认使用优惠码，是否继续下单？'
                return rps
            }

            //判断是否勾选了确认使用
            if (!this.formCustom.isChecked && !this.isCouponShow && this.isAgentShow) {
                rps.iswarning = true
                rps.rltdesc = '您没有确认使用运营商编码，是否继续下单？'
                return rps
            }
            //1.有优惠码也有运营商编码
            if (this.isCouponShow && this.isAgentShow) {

                //判断是否填写
                if (this.formCustom.couponValue === '' && this.formCustom.agencies === '') {
                    rps.iswarning = true
                    rps.rltdesc = '您没有填写优惠码和运营商编码，是否继续下单？'
                    return rps
                } else if (this.formCustom.couponValue !== '' && this.formCustom.couponValue !== '' && this.formCustom.isChecked === false) {
                    rps.iswarning = true
                    rps.rltdesc = '您填写优惠码和运营商编码但没有确认使用，是否继续下单？'
                    return rps
                } else if (this.formCustom.couponValue !== '' && this.formCustom.isChecked === false) {
                    rps.iswarning = true
                    rps.rltdesc = '您填写优惠码但没有确认使用优惠码，是否继续下单？'
                    return rps
                } else if (this.formCustom.agencies !== '' && this.formCustom.isChecked === false) {
                    rps.iswarning = true
                    rps.rltdesc = '您填写运营商编码但没有确认使用运营商编码，是否继续下单？'
                    return rps
                }



                //判断优惠码和运营商编码的错误状态以及是否为空
                if (!this.isRightPromoCode && !this.isRightAgentCode) {
                    if (this.formCustom.couponValue === '' && this.formCustom.agencies === '') {
                        rps.iswarning = true
                        rps.rltdesc = '您没有填写优惠码和运营商编码，是否继续下单？'
                        return rps
                    } else if (this.formCustom.couponValue === '' && this.formCustom.agencies !== '') {
                        rps.iswarning = true
                        let errMsg = this.rspItem.item.agentrltdesc
                        rps.rltdesc = '您没有填写优惠码且' + errMsg + '，是否继续下单？'
                        this.formCustom.agencies = ''
                        return rps
                    } else if (this.formCustom.couponValue !== '' && this.formCustom.agencies === '') {
                        rps.iswarning = true
                        let errMsg = this.rspItem.item.couponrltdesc
                        rps.rltdesc = '您没有填写运营商编码且' + errMsg + '，是否继续下单？'
                        this.formCustom.couponValue = ''
                        return rps
                    } else if (this.formCustom.couponValue !== '' && this.formCustom.agencies !== '') {
                        rps.iswarning = true
                        let errMsg1 = this.rspItem.item.couponrltdesc
                        let errMsg2 = this.rspItem.item.agentrltdesc
                        rps.rltdesc = '' + errMsg1 + '且' + errMsg2 + '，是否继续下单？'
                        this.formCustom.couponValue = ''
                        this.formCustom.agencies = ''
                        return rps
                    }

                } else if (!this.isRightPromoCode) {

                    if (this.formCustom.couponValue === '') {
                        rps.iswarning = true
                        rps.rltdesc = '您没有填写优惠码，是否继续下单？'
                        this.formCustom.couponValue = ''
                    } else {
                        rps.iswarning = true
                        let errMsg = this.rspItem.item.couponrltdesc
                        rps.rltdesc = '' + errMsg + '，是否继续下单？'
                        this.formCustom.couponValue = ''
                    }

                    //验证不通过，提交空数据

                } else if (!this.isRightAgentCode) {
                    //验证不通过，提交空数据
                    if (this.formCustom.agencies === '') {
                        rps.iswarning = true
                        rps.rltdesc = '您没有填写运营商编码，是否继续下单？'
                        this.formCustom.agencies = ''
                    } else {
                        rps.iswarning = true
                        let errMsg = this.rspItem.item.agentrltdesc
                        rps.rltdesc = '' + errMsg + '，是否继续下单？'
                        this.formCustom.agencies = ''
                    }
                } else {
                    rps.iswarning = false
                    rps.rltdesc = ''
                    return rps
                    console.log('其他场景===>')
                    console.log("this.isRightPromoCode:" + this.isRightPromoCode, "this.isRightAgentCode:" + this.isRightAgentCode, )
                }

                //2.有优惠码没有运营商编码
            } else if (this.isCouponShow && !this.isAgentShow) {

                if (this.formCustom.couponValue === '') {
                    rps.iswarning = true
                    rps.rltdesc = '您没有填写优惠码，是否继续下单？'
                    return rps
                } else if (this.formCustom.couponValue !== '' && this.formCustom.isChecked === false) {
                    rps.iswarning = true
                    rps.rltdesc = '您填写优惠码但没有确认使用优惠码，是否继续下单？'
                    return rps
                }

                if (!this.isRightPromoCode) {
                    if (this.formCustom.couponValue === '') {
                        rps.iswarning = true
                        rps.rltdesc = '您没有填写优惠码，是否继续下单？'
                        return rps
                    } else if (this.formCustom.couponValue !== '') {
                        rps.iswarning = true
                        let errMsg = this.rspItem.item.couponrltdesc
                        rps.rltdesc = errMsg + '，是否继续下单？'
                        this.formCustom.couponValue = ''
                        return rps
                    }
                }
                //3.无优惠码有运营商编码
            }else if(!this.isCouponShow && this.isAgentShow){
                if (this.formCustom.agencies === '') {
                    rps.iswarning = true
                    rps.rltdesc = '您没有填写运营商，是否继续下单？'
                    return rps
                } else if (this.formCustom.agencies !== '' && this.formCustom.isChecked === false) {
                    rps.iswarning = true
                    rps.rltdesc = '您填写了运营商编码但没有确认使用优惠码，是否继续下单？'
                    return rps
                }

                if (!this.isRightAgentCode) {
                    if (this.formCustom.agencies === '') {
                        rps.iswarning = true
                        rps.rltdesc = '您没有填写运营商编码，是否继续下单？'
                        return rps
                    } else if (this.formCustom.agencies !== '') {
                        rps.iswarning = true
                        let errMsg = this.rspItem.item.agentrltdesc
                        rps.rltdesc = errMsg + '，是否继续下单？'
                        this.formCustom.agencies = ''
                        return rps
                    }
                }
            }


            return rps

        },
        checkPromoCode(call) {
            let code = this.formCustom.couponValue
            var that = this
            //if (this.formCustom.couponValue === '') { return }
            constJ.reqCheckCoupon(code).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.$Message.success(res.item.coupondesc)
                    this.isRightPromoCode = true
                    call()
                } else {
                    //this.couponError=res.rltdesc
                    //this.$Message.info(res.rltdesc)
                    this.isRightPromoCode = false
                    call(new Error(res.rltdesc))
                }
            }).catch(function(e) {
                that.$Message.error(e.message)
                this.isRightPromoCode = false
                call(new Error('优惠码验证异常'))
                return
            })
        },
        checkAgentCode(call) {
            let code = this.formCustom.agencies
            var that = this
            //if (this.formCustom.agencies === '') { return }
            constJ.reqCheckAgency(code).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.$Message.info(res.item.agentname)
                    this.isRightAgentCode = true
                    call()

                } else {
                    //this.couponError=res.rltdesc
                    //this.$Message.info(res.rltdesc)
                    this.isRightAgentCode = false
                    call(new Error(res.rltdesc))
                }
            }).catch(function(e) {
                that.$Message.error(e.message)
                call(new Error('运营商编码验证异常'))
                this.isRightAgentCode = false
                return
            })
        },
        clean() {
            console.log('clean coupon message!')
            this.formCustom.couponValue = ""
            this.formCustom.agencies = ""
            this.formCustom.isChecked = false
            this.isRightPromoCode = false
            this.isRightAgentCode = false
            this.agentrltdesc=''
            this.couponrltdesc=''
            this.rspItem.item = {}

        },
    },


}
</script>
<style lang="less" scoped>
#mainform1/deep/.ivu-form-item{
        margin-bottom: 2px;//formitem 行间距
}
</style>